export default {"src":"/_next/static/image/public/images/flags/flag_40.3e73ba82045f8016df55df654ecb80aa.svg","height":16,"width":24};